import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	Tag,
	Modal,
	Statistic,
	Input,
	Select,
	Col,
	Row,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import {
	EditFilled,
	PlusCircleFilled,
	AimOutlined,
	DollarCircleOutlined,
	RollbackOutlined,
} from "@ant-design/icons";
import ModalPSITotals from "./ModalPSITotals";
import ModalPSIAggregate from "./ModalPSIAggregate";
import { franchises57Options } from "../../constants/Customer";
const { Text } = Typography;
const { Search } = Input;

const statusOptions = [
	{
		value: "All",
		label: "All",
	},
	{
		value: "Active",
		label: "Active",
	},
	{
		value: "Inactive",
		label: "Inactive",
	},
];

const PsiList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [productList, setProductList] = useState([]);
	const [term, setTerm] = useState("");
	const [status, setStatus] = useState("Active");
	const [franchise, setFranchise] = useState("57Concrete");
	const [modalOpen, setModalOpen] = useState(false);
	const [modalOpenAggregate, setModalOpenAggregate] = useState(false);
	const psiId = useRef(null);
	const psiName = useRef(null);

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Flex gap={"small"}>
						<Button
							type="primary"
							icon={<EditFilled twoToneColor={"white"} />}
							onClick={(e) => history.push(`/psi/${record.id}`)}
							size="large"
						/>

						<Button
							type="primary"
							icon={<AimOutlined twoToneColor={"white"} />}
							onClick={(e) => {
								psiId.current = record.id;
								psiName.current = record.name;
								setModalOpen(true);
							}}
							size="large"
						/>
						<Button
							type="primary"
							icon={<DollarCircleOutlined twoToneColor={"white"} />}
							onClick={(e) => {
								psiId.current = record.id;
								psiName.current = record.name;
								setModalOpenAggregate(true);
							}}
							size="large"
						/>
					</Flex>
				);
			},
		},
		{
			title: "",
			dataIndex: "active",
			render: (value) => {
				return (
					<Tag color={value ? "green" : "red"}>
						{value ? "Active" : "Inactive"}
					</Tag>
				);
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			disabled: true,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Product/Service",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Description",
			dataIndex: "description",
			key: "description",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Strength",
			dataIndex: "strength",
			key: "strength",
			render: (value) => {
				if (!value) return <Text>-</Text>;
				return <Statistic value={value} valueStyle={{ fontSize: "14px" }} />;
			},
		},
		{
			title: "Minimum Price",
			dataIndex: "minPrice",
			key: "minPrice",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						prefix="$"
						valueStyle={{ fontSize: "14px" }}
					/>
				);
			},
		},
		{
			title: "Maximum Price",
			dataIndex: "price",
			key: "price",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						prefix="$"
						valueStyle={{ fontSize: "14px" }}
					/>
				);
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag color={value === "57Concrete" ? "green" : "cyan"}>{value}</Tag>
				);
			},
		},
	];

	useEffect(() => {
		getProductList();
	}, [term, status, franchise]);

	const getProductList = async () => {
		setLoading(true);

		const url = api + `/psi/search/${franchise}?term=${term}&status=${status}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.map((item, index) => {
				list.push({
					key: index,
					id: item._id,
					name: item.psi,
					description: item.description,
					price: item.price ? item.price : 0,
					minPrice: item.minPrice ? item.minPrice : 0,
					strength: item.strength,
					active: item.active,
					date: Intl.DateTimeFormat("en-US").format(new Date(item.createdAt)),
					franchise: item.franchise || "57Concrete",
				});
			});
			setProductList(list);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewProduct = () => {
		history.push("/psi/new");
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<CustomTable columns={columns} data={productList} />
			</Flex>
		);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderSearch = () => (
		<Flex gap={"large"}>
			<Select
				showSearch
				placeholder={`Select status`}
				optionFilterProp="children"
				size="large"
				onChange={(value) => setStatus(value)}
				filterOption={filterOption}
				options={statusOptions}
				disabled={loading}
				defaultValue={"All"}
				value={status}
				style={{
					width: 200,
				}}
				allowClear={false}
			/>
			<Select
				showSearch
				placeholder={`Select franchise`}
				optionFilterProp="children"
				size="large"
				onChange={(value) => setFranchise(value)}
				filterOption={filterOption}
				options={franchises57Options}
				disabled={loading}
				defaultValue={"57Concrete"}
				value={franchise}
				style={{
					width: 200,
				}}
				allowClear={false}
			/>
			<Search
				placeholder="Search"
				enterButton
				onSearch={(value) => setTerm(value)}
				allowClear
				style={{
					width: 400,
				}}
				size="large"
				loading={loading}
				disabled={loading}
			/>
		</Flex>
	);

	const RenderModal = () => {
		return (
			<Modal
				title={`PSI Totals of ${psiName.current}`}
				open={modalOpen}
				onCancel={() => setModalOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
				centered
			>
				<ModalPSITotals psiId={psiId.current} psiName={psiName.current} />
			</Modal>
		);
	};

	const RenderModalAggregate = () => {
		return (
			<Modal
				title={`PSI Aggregates from ${psiName.current}`}
				open={modalOpenAggregate}
				onCancel={() => setModalOpenAggregate(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
				centered
			>
				<ModalPSIAggregate psiId={psiId.current} />
			</Modal>
		);
	};

	const goBack = () => {
		history.goBack();
	};

	return (
		<Layout title="Products" description="Product List">
			<Flex vertical gap={"large"}>
				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							size="large"
							icon={<RollbackOutlined />}
							onClick={goBack}
						/>
					</Col>
					<Col>
						<Button
							onClick={addNewProduct}
							type="primary"
							style={{
								width: 150,
							}}
							icon={<PlusCircleFilled />}
							size="large"
							disabled={loading}
							loading={loading}
						>
							New Product
						</Button>
					</Col>
				</Row>

				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderTable />}
				<RenderModal />
				<RenderModalAggregate />
			</Flex>
		</Layout>
	);
};

export default PsiList;
